var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFamilyEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 8) rotate(45) translate(-2 -7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 3H0V10.6972C0 10.8946 0.058438 11.0877 0.16795 11.2519L2 14L3.83205 11.2519C3.94156 11.0877 4 10.8946 4 10.6972V3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1C0 0.447715 0.447715 0 1 0H3C3.55228 0 4 0.447715 4 1V2H0V1Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilyEdit);
export default __webpack_public_path__ + "static/media/family-edit.546d85ca8ae4fb3f6b14f47eaf05d359.svg";
export { ForwardRef as ReactComponent };